/**
 * frontend-log-mixin.js
 * フロントエンドログ関連Mixin
 */

/**
 * フロントエンドログ関連Mixin
 */
const FrontendLogMixin = {
  props: {
    PCTRLLOG: {
      //親のgetComponentTags
      type: Function,
      require: false
    },
  },
  data () {
    return {
      // ログレベル
      LOG_LEVEL: {
        // デバッグ
        DEBUG: 0,
        // 操作
        OPERATION: 1,
        // 情報
        INFO: 2,
        // 警告
        WARNING: 3,
        // エラー
        ERROR: 4,
        // 致命的
        CRITICAL: 5
      }
    }
  },
  computed: {
    CTRLLOG () {
      //エイリアス
      return this._getComponentTags
    }
  },
  mounted () {
    const componentTag = this.$options._componentTag
    if (!componentTag && !this.COMPONENT_NAME) {
      console.error(
        'The root component on the current route ' + this.$route.fullPath
        + ' (configured in Vue.router) does not have the "COMPONENT_NAME" property.\n'
        + 'Prease set "data () {return {COMPONENT_NAME: ____}}".')
    }
  },
  methods : {
    /**
     * フロントエンドログ登録ペイロード作成
     * @param {Boolean} raiseError 例外有無
     */
    _getComponentTags(raiseError) {
      if (raiseError) {
        if (!this.PCTRLLOG) {
          const componentTag = this.$options._componentTag
          if (componentTag) {
            console.error('The control-log-chain is broken at <' + componentTag + '>.\n'
              + "The parent component's control-log-method is not bound to <" + componentTag + ">.\n"
              + 'Please bind using :PCTRLLOG="CTRLLOG".')
          }
          else {
            console.warn('There is nothing wrong with the control log chain.')
          }
        }
        else this.PCTRLLOG(true)
      }
      else {
        const componentTag = this.$options._componentTag
        if (!componentTag) {
          return [(this.COMPONENT_NAME || "NoNameComponent")]
        }
        else if (!this.PCTRLLOG) return null
        else {
          const tagHierarchy = this.PCTRLLOG(false)
          if (tagHierarchy) return tagHierarchy.concat([componentTag])
          else null
        }
      }
    },
    /**
     * 企業側フロントエンドログ登録
     * @param {Number} logLevel ログレベル
     * @param {String} caption 概要
     * @param {String} description 詳細
     * @param {Object} options オプション
     * @param {String} seekerId 求職者ID
     */
    sendSystemLog(logLevel, caption, description, options={}, seekerId=null) {
      const tagHierarchy = this._getComponentTags(false)
      if (tagHierarchy) {
        const logData = {
          component: tagHierarchy.join(','),
          log_level: logLevel,
          caption: caption,
          description: description,
          url: this.$route.fullPath,
          userAgent: window.navigator.userAgent,
          options: options,
          seeker: seekerId
        }
        this.$store.dispatch('frontendLog/sendSystemLog', logData)

        // 操作ログは別途でも保存する
        if (logLevel === this.LOG_LEVEL.OPERATION) {
          const controlLogData = {
            caption: caption,
            description: description,
            url: this.$route.fullPath,
            vue_component: tagHierarchy.join(','),
            user_agent: window.navigator.userAgent,
            options: options,
            seeker: seekerId
          }
          this.$store.dispatch('auth/sendControlLog', controlLogData)
        }
      }
    },
    /**
     * 求職者側フロントエンドログ登録
     * @param {Number} logLevel ログレベル
     * @param {String} caption 概要
     * @param {String} description 詳細
     * @param {Object} options オプション
     * @param {String} seekerId 求職者ID
     */
    sendSeekerLog(logLevel, caption, description, options={}, seekerId=null) {
      const tagHierarchy = this._getComponentTags(false)
      if (tagHierarchy) {
        const logData = {
          component: tagHierarchy.join(','),
          log_level: logLevel,
          caption: caption,
          description: description,
          url: this.$route.fullPath,
          userAgent: window.navigator.userAgent,
          options: options,
          seeker: seekerId
        }
        this.$store.dispatch('frontendLog/sendSeekerLog', logData)
      }
    },
    /**
     * ロボ用ログオプション情報作成
     * @param {Object} robo ロボ情報
     * @return ログオプション情報
     */
    makeRoboOptions(robo) {
      return {'ロボ情報': {'ロボ管理名': robo.name, 'ロボ表示名': robo.disp_name, 'ID': robo.bot_id}}
    },
    /**
     * 求職者用ログオプション情報作成
     * @param {Object} robo ロボ情報
     * @return ログオプション情報
     */
    makeSeekerOptions(seeker, widgetData) {
      return {'求職者情報': {'求職者名': seeker.name, 'ID': seeker.id, '応募(訪問)会社名': widgetData.companyName}}
    }
  }
}

export default FrontendLogMixin


// WEBPACK FOOTER //
// ./src/hrm-frontend/views/mixins/frontend-log-mixin.js